module.exports = __webpack_public_path__ + "img/id.68e61b63.png";